import React from "react";
import { connect } from "react-redux";
import { HashRouter, BrowserRouter as Router, Route, Switch } from "react-router-dom";
import SubNavBar from "./SubNavBar";
import { Spinner } from "react-bootstrap";
import { NavigationComponent } from "../types";
import StudentProfileView from "../components/StudentProfileView";
import StudentController from "../api/StudentController";
import { withData } from "../common/WithData";
import AccessLogs from "../pages/AccessLogs";
import AboutStudent from "../pages/AboutStudent";
import NotFound from "../pages/NotFound";

interface MainAppProps
{
    title: string;
    appSetup: NavigationComponent[];
    role: string;
    data: any;
}

class MainApp extends React.Component<MainAppProps>
{
    studentController: StudentController;

    constructor(props: MainAppProps) 
    {
        super(props);
        this.studentController = new StudentController();
    }

    render(): React.ReactNode 
    {
        const roleTabs = this.props.appSetup.filter(itm => itm.role.includes(this.props.role));
        let landingPage = "accessLog";

        if (this.props.role != "student")
            landingPage = "about";

        const StudentProfileData = withData(
            StudentProfileView,
            "Student Profile",
            async () => await this.studentController.getStudent()
        );

        return this.props.title ? <HashRouter hashType={"slash"}>
            <StudentProfileData />
            <SubNavBar appSetup={roleTabs} landingPage={landingPage} studentId={this.props.student.kerbId} />
            <div className={"main-content"}>
                <Switch>
                    <Route exact path={"/"}>
                        {
                            this.props.role == "student"
                                ?
                                <AccessLogs />
                                :
                                <AboutStudent />
                        }
                    </Route>
                    {roleTabs.map(page => 
                    {
                        return (<Route key={page.id} exact path={"/" + page.id + "/:studentId?"}>
                            {page.Component}
                        </Route>);
                    })}
                    <Route path="*">
                        <NotFound />
                    </Route>
                </Switch>
            </div>
        </HashRouter> : <Spinner animation="border" />;
    }
}

const mapStateToProps = (state: any) => ({
    student: state.student.activeStudent,
    role: state.app.user.role
});

export default connect(mapStateToProps)(MainApp);